module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_top_affiliates-cfac95601972c92a0fbaa9b7ded35b70.png";